import { Dialog, DialogContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { FormButtons } from './form-buttons.component';
import { EmployeeInfo } from './employee-info.component';
import { Employee } from '../../../../models/masters/employee';
import { EmployeeAddress } from './employee-address.component';
import { EmployeeDetails } from './Employee-details.component';
import { useReactHookForm } from '../../../../hooks/useReactHookForm';
import { ReactHookForm } from '../../../../components/hook-form/react-hook-form.component';
import { FastFieldComponent } from './fast-field.component';
import { usersApiKeyStore } from '../../../../api/users-api-key-store';
import { useSaveData } from '../../../../hooks/useSaveData';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import EmployeePasswordReset from './employee-password-reset';

interface SaveEmployeeComponent {
  employee: Employee;
  yupSchema?: any;
}

export const SaveEmployeeComponent = ({ employee, yupSchema }: SaveEmployeeComponent) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { isLoading, mutateAsync } = useSaveData<any>(usersApiKeyStore.createUser());

  const form = useReactHookForm({
    defaultValues: {
      ...employee,
      state: { stateID: employee?.state ? employee?.state : 0, stateName: '' },
      // userRoles:
      //   employee?.userRoles?.length > 0
      //     ? { roleID: employee?.userRoles?.length > 0 ? employee?.userRoles[0].roleID : '', roleName: '' }
      //     : null,
      userDepartments: {
        departmentID: employee?.userDepartments?.length > 0 ? employee?.userDepartments[0].departmentID : 0,
        departmentName: '',
      },
      isActive: employee?.userID ? Boolean(employee?.isActive) ?? false : true,
    },
    yupSchema: yupSchema,
  });

  const handleSubmit = async (data: any) => {
    await mutateAsync({
      data: {
        ...data,
        state: data.state?.stateID,
        userRoles: data?.userRoles?.map((item: any) => item.roleID),
        userDepartments: [data.userDepartments?.departmentID],
        userEquipments: data.userEquipments?.map((item: any) => item.equipmentID),
        userMarketAreas: data.userMarketAreas?.map((item: any) => item.marketAreaID),
        userManagers: data.userManagers?.map((item: any) => item.userID),
      },
    });
    navigate('/masters/employee');
  };

  const handleEpmpoyeeRestPassword = () => {
    setIsOpen(true);
  };

  return (
    <>
      <ReactHookForm formName="EDIT_EMPLOYEE_FORM" onSubmit={handleSubmit} formContextProps={form} isBusy={isLoading}>
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <EmployeeInfo employee={employee} handleEpmpoyeeRestPassword={handleEpmpoyeeRestPassword} />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <EmployeeDetails />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <EmployeeAddress userID={employee?.userID ?? null} />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <FastFieldComponent userID={employee?.userID ?? null} />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <FormButtons isLoading={false} />
          </Grid>
        </Grid>
      </ReactHookForm>
      {isOpen && (
        <Dialog
          open={isOpen}
          fullWidth={true}
          maxWidth={'sm'}
          // onClose={handleClosed}
          aria-labelledby="dialog-title"
          aria-describedby="dialog-description"
        >
          <IconButton
            aria-label="close"
            onClick={() => {
              setIsOpen(false);
            }}
            sx={{
              position: 'absolute',
              right: 10,
              top: 3,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Tooltip title={<Typography variant="body1">Close</Typography>}>
              <CloseIcon />
            </Tooltip>
          </IconButton>
          <DialogContent dividers className="popupDilog">
            <EmployeePasswordReset userID={employee?.userID ?? null} handleClose={() => setIsOpen(false)} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
